import {
  toResponseError,
  type GameAddInput,
  type GameAddSuccess,
  type GameData,
  type UnsavedGame,
} from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { type AddHookResponse, mutationAdd } from '../hooks'
import { useGameCache } from './cache'

export function useAddGame(): AddHookResponse<UnsavedGame, GameData> {
  const cache = useGameCache()
  const mutation = useTantalimMutation<GameAddInput, GameAddSuccess>({ url: '/game/add' })

  async function add(game: UnsavedGame): Promise<GameData> {
    try {
      const output = await mutation.mutateAsync({ game, version: 2 })
      cache.addListItem(output.game)
      return output.game
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
